<template>
    <div class="modal__postal-code-form">
        <h2 class="postal-form__title">Please provide your postal code</h2>
        <p class="postal-form__desc">
            We use your location to provide accurate shipping and stock
            availability information - ensuring your tires are in stock & ready
            to ship.
        </p>


        <form class="postal-form" @submit="submitPostal">
            <div v-if="isError" class="post-form__error post-form__error--white-pill">
                The postal code provided is invalid
            </div>
            <div class="postal-form__input-wrapper">
                <input :disabled="isLoading" masked="false" required class="postal-form__input" type="text" name="mask"
                    v-model="postalCode" v-mask="'S0S 0S0'" />
            </div>

            <button v-if="canDetectLocation" :disabled="isLoading" @click="detectLocation" type="button"
                class="postal-form__detect">
                Detect my location
            </button>

            <p class="post-form__error" v-else>
                You must enable site access to your location in order to use the "Detect Location" function
            </p>

            <button class="button button--white button--large" type="submit">Continue</button>
        </form>


    </div>
</template>

<script>
import { getCookie, saveLatLongCookies, generateCookieExpiry, getUsersCurrentLocation, getLongAndLatFromPostal, deleteCookiesByName } from "../scripts/helpers"
export default {
    data() {
        return {
            postalCode: decodeURI(getCookie('postal')),
            usedDetectLocation: false,
            canDetectLocation: false,
            isError: false,
        };
    },

    props: {
        isLoading: {
            type: Boolean
        }
    },

    mounted() {
        navigator.permissions.query({ name: 'geolocation' })
            .then(permissionStatus => {
                if (permissionStatus.state === 'granted') {
                    this.canDetectLocation = true
                }

                permissionStatus.onchange = () => {
                    this.canDetectLocation = permissionStatus.state === 'granted' || false
                };
            })
    },

    methods: {
        detectLocation() {
            this.$emit('setIsLoading', true)
            this.isError = false
            getUsersCurrentLocation(this.handleSuccessfulLocationFind, false, false, true)
        },
        async submitPostal(e) {
            e.preventDefault();
            // We need to retrieve the Longitude and Latitude from the user's input if they did not use
            // The Detect Location feature.
            if (this.postalCode.length !== 7) {
                return
            }
            this.isError = false
            this.$emit('setIsLoading', true)
            try {
                const location = await getLongAndLatFromPostal(this.postalCode)
                this.checkIfValid(location)
                const long = location.results[0].geometry.location.lng()
                const lat = location.results[0].geometry.location.lat()
                let city = ''
                let province = ''
                const addressComponents = location.results[0].address_components;
                addressComponents.forEach((comp) => {
                    if (comp.types.includes("locality")) {
                        city = comp.short_name;
                    }
                    if (comp.types.includes("administrative_area_level_1")) {
                        province = comp.short_name;
                    }
                });
                const cookieExpiry = generateCookieExpiry()
                deleteCookiesByName("city");
                deleteCookiesByName("province");
                document.cookie = `city=${city}; expires=${cookieExpiry}; path=/`;
                document.cookie = `province=${province}; expires=${cookieExpiry}; path=/`;
                saveLatLongCookies(long, lat)
                this.$emit('sendPostalCode', this.postalCode)
            } catch (error) {
                this.isError = true
                this.$emit('setIsLoading', false)
            }

        },


        checkIfValid(location) {
            const invalidPostal = location.results[0].partial_match
            if (invalidPostal) {
                throw new Error('The Postal Code provided is invalid');
            }

        },

        handleSuccessfulLocationFind(postal) {
            this.$emit('setIsLoading', false)
            this.postalCode = postal
            this.usedDetectLocation = true;
        }
    },
};
</script>

<style lang="scss" scoped></style>